import styled from 'styled-components';

export const Container = styled.section`
  display: ${({ $show }) => ($show ? 'flex' : 'none')};
  flex-direction: column;
  gap: 48px;
  padding: 0 28px;

  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
  }
`;

export const Empty = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  padding: 20px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.colors.grey[500]};
  border: 1px solid ${({ theme }) => theme.colors.grey.white};

  a {
    text-decoration: underline;

    &:hover {
      transition: 0.7s;
      opacity: 0.8;
    }
  }
`;

export const GroupRow = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 48px;

  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
  }
`;

export const GroupCollumn = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  h2 {
    font-family: 'Bebas Neue', sans-serif;
    font-weight: 300;
    font-size: 40px;
    margin-top: 28px;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 24px;
    }
  }
`;

export const GroupDescription = styled.div`
  width: 100%;
  padding: 12px;
  display: flex;
  gap: 8px;
`;

export const GroupInfos = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
  }
`;
export const TopInfos = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
    justify-content: center;
    gap: 8px;
  }
`;

export const TopInfosStatus = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  span {
    margin-bottom: -3px;
    color: ${({ theme }) => theme.colors.outher.success};
  }

  > div {
    width: 12px;
    height: 12px;
    border-radius: 100%;
    background-color: ${({ theme }) => theme.colors.outher.success};
  }
`;

export const TopInfosGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
`;

export const ButtonInfos = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  position: relative;
  padding: 10px 32px;
  border: none;
  color: ${({ theme }) => theme.colors.grey.white};
  border-radius: 25px;
  z-index: 0;

  p {
    margin-bottom: -4px;
    z-index: 1;
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 25px;
    background: ${({ theme }) => theme.colors.gradient.fullX};
    opacity: 0.3;
    z-index: -2;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 25px;
    padding: 2px;
    background: ${({ theme }) => theme.colors.gradient.fullX};
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    z-index: -1;
  }

  &:hover {
    &::before {
      transition: 0.7s;
      opacity: 1;
    }
  }
`;

export const DescriptionInfos = styled.div`
  padding-top: 20px;
  border-top: 1px solid ${({ theme }) => theme.colors.grey[500]};

  @media ${({ theme }) => theme.devices.mobile} {
    padding-top: 12px;
    margin-top: 12px;
    text-align: center;
  }
`;

export const BottomInfos = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 12px;
`;

export const PrinceInfos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 20px;
  gap: 12px;

  h1 {
    margin-top: 2px;
    font-size: 52px;
    font-family: 'Bebas Neue', sans-serif;
    font-weight: 700;
  }

  span {
    display: flex;
    align-items: center;
    gap: 4px;

    h3 {
      margin-bottom: -2px;
    }
  }
`;

export const PhoneInfos = styled.div`
  width: 100%;
  margin-top: 12px;

  a {
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    /* padding: 6px 28px 6px 8px; */
    padding: 6px;
    width: 100%;
    border-radius: 48px;
    background-color: ${({ theme }) => theme.colors.grey.white};
    color: ${({ theme }) => theme.colors.grey.black};

    img {
      width: 48px;
      height: 48px;
    }

    div {
      display: flex;
      flex-direction: column;
      gap: 4px;

      h4 {
        font-size: 20px;
      }

      span {
        font-size: 14px;
        margin-bottom: -2px;
      }
    }

    &:hover {
      transition: 0.7s;
      opacity: 0.8;
    }
  }
`;
export const GroupUl = styled.div`
  margin-bottom: 40px;

  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
  }

  div {
    display: flex;
    gap: 16px;

    @media ${({ theme }) => theme.devices.mobile} {
      gap: 4px;
    }
  }

  h3 {
    display: flex;
    width: 100%;
    padding: 8px 20px 4px 16px;
    border-radius: 12px;
    background-color: ${({ theme }) => theme.colors.grey.white};
    color: ${({ theme }) => theme.colors.grey.black};

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 20px;
    }
  }

  ul {
    width: 50%;
    /* max-width: 172px; */
    /* background-color: red; */
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    gap: 12px;
    padding-left: 0;
    list-style: none;

    @media ${({ theme }) => theme.devices.mobile} {
      width: 100%;
    }

    li {
      display: flex;
      align-items: center;
      gap: 12px;
      position: relative;
      padding-left: 18px;

      @media ${({ theme }) => theme.devices.mobile} {
        width: 100%;
        padding-left: 8px;
        justify-content: flex-start;
      }

      b {
        font-weight: 700;
        margin-right: 4px;

        @media ${({ theme }) => theme.devices.mobile} {
          margin-right: 0px;
        }
      }

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: ${({ theme }) => theme.colors.grey.white};

        @media ${({ theme }) => theme.devices.mobile} {
          top: 6px;
          width: 4px;
          height: 4px;
        }
      }
    }
  }

  .this-list {
    max-width: 100%;
    border-left: 1px solid ${({ theme }) => theme.colors.grey[500]};
    padding-left: 16px;

    @media ${({ theme }) => theme.devices.mobile} {
      padding-left: 4px;
    }
  }
`;

export const EmptyInfo = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const GroupLinks = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  a {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 16px 32px;
    border: 1px solid ${({ theme }) => theme.colors.primary.darkest};
    background-color: transparent;
    border-radius: 8px;

    &:hover {
      background-color: ${({ theme }) => theme.colors.grey[700]};
      transition: 0.7s;
    }

    svg {
      width: 32px;
      height: 32px;
    }

    span {
      text-align: center;
    }
  }
`;

export const ViewModel = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  button {
    gap: 4px;
    padding: 12px 32px;
    color: ${({ theme }) => theme.colors.grey.white};
  }
`;

export const Top = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;

  h3 {
    color: ${({ $color }) => $color};
  }

  span {
    padding: 8px 16px;
    border: 1px solid ${({ $color }) => $color};
    color: ${({ $color }) => $color};
    background-color: color-mix(
      in srgb,
      ${({ $color }) => $color} 20%,
      transparent
    );
    border-radius: 16px;
  }

  svg {
    width: 32px;
    color: ${({ $color }) => $color};

    path {
      stroke-width: 2.5px;
    }
  }
`;

export const Grid = styled.div`
  width: 100%;
  display: ${({ $show }) => ($show ? 'flex' : 'none')};
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 20px;
`;

export const Box = styled.div`
  border-right: 1px solid rgba(256, 256, 256, 0.2);
  border-bottom: 1px solid rgba(256, 256, 256, 0.2);
  padding: 16px;
  color: ${({ theme }) => theme.colors.grey.white};
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 33%;

  > div {
    width: 100%;
    display: flex;
    align-items: center;
  }

  small {
    font-size: 12px;
  }

  /* Remove borda direita da 3ª coluna */
  &:nth-child(3n) {
    border-right: none;
  }

  /* Remove borda inferior da última linha */
  &:nth-last-child(-n + 3) {
    border-bottom: none;
  }

  > div {
    display: flex;
    align-items: center;
    gap: 8px;

    .content {
      width: 16px;
      height: 16px;
      border: 1px solid ${({ theme }) => theme.colors.grey[100]};
      border-radius: 4px;
      background-color: transparent;
    }
  }

  @media ${({ theme }) => theme.devices.tablet} {
    max-width: 50%;
    border-right: 0;

    &:nth-child(1n) {
      border-bottom: 1px solid rgba(256, 256, 256, 0.2);
    }

    &:nth-child(2n) {
      border-left: 1px solid rgba(256, 256, 256, 0.2);
      border-bottom: 1px solid rgba(256, 256, 256, 0.2);
    }
  }
`;

export const BoxText = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-right: 20px;

  > div {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 8px;

    &:nth-child(${({ $value }) => $value}) .content {
      background-color: ${({ theme }) => theme.colors.grey[100]};
    }

    .content {
      width: 16px;
      height: 16px;
      border: 1px solid ${({ theme }) => theme.colors.grey[100]};
      background-color: transparent;
      border-radius: 4px;
    }

    span {
      margin-bottom: -3px;
    }
  }
`;

export const FilterButtons = styled.div`
  display: flex;
  gap: 12px;
  margin: 20px 0;

  button {
    padding: 12px 32px;
    border: 2px solid ${({ theme }) => theme.colors.grey.white};
    background: transparent;
    color: ${({ theme }) => theme.colors.grey.white};
    border-radius: 36px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      opacity: 0.7;
    }
  }

  .active {
    border-color: ${({ $color }) => $color};
    color: ${({ $color }) => $color};
    background-color: color-mix(
      in srgb,
      ${({ $color }) => $color} 20%,
      transparent
    );
    transform: scale(1.1);
  }

  @media ${({ theme }) => theme.devices.mobile} {
    flex-wrap: wrap;
  }
`;
